import 'styles/index.css';

import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'theme-ui';

import App from 'components/App';
import store from 'store';
import { theme } from 'ui';

const ReduxProvider = Provider as any;

ReactDOM.render(
  <ReduxProvider store={store}>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </ReduxProvider>,
  document.getElementById('root')
);
